import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Clock } from 'lucide-react';
import Seo from './Seo';
import NotFound from './NotFound';
import { POSTS, getPost } from '../blog/posts';
import './Blog.css';

const fmtDate = (d) =>
  new Date(d + 'T00:00:00').toLocaleDateString('sv-SE', { day: 'numeric', month: 'long', year: 'numeric' });

export function BlogIndex() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="blog container">
      <Seo
        title="Blogg – guider om hemsidor, SEO och synlighet | Briljans"
        description="Ärliga guider från en webbyrå i Falun: vad hemsidor kostar, hur du syns på Google och hur du får din hemsida att jobba för dig."
        path="/blogg"
      />
      <div className="blog-header">
        <span className="blog-eyebrow">Blogg</span>
        <h1>Guider om hemsidor & synlighet</h1>
        <p>Ärliga svar på frågorna vi oftast får — utan säljsnack.</p>
      </div>
      <div className="blog-list">
        {POSTS.map((post) => (
          <Link key={post.slug} to={`/blogg/${post.slug}`} className="blog-card">
            <img
              className="blog-card-cover"
              src={`/images/blogg/${post.slug}.png`}
              alt=""
              loading="lazy"
            />
            <div className="blog-card-meta">
              <span>{fmtDate(post.date)}</span>
              <span className="blog-card-reading"><Clock size={13} /> {post.readingMinutes} min</span>
            </div>
            <h2>{post.title}</h2>
            <p>{post.description}</p>
            <span className="blog-card-more">Läs artikeln <ArrowRight size={15} /></span>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const post = getPost(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) return <NotFound />;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: post.title,
    description: post.description,
    datePublished: post.date,
    image: `https://briljans.se/images/blogg/${post.slug}.png`,
    inLanguage: 'sv',
    author: { '@type': 'Organization', name: 'Briljans', url: 'https://briljans.se/' },
    mainEntityOfPage: `https://briljans.se/blogg/${post.slug}`,
  };

  return (
    <div className="blog blog-post container">
      <Seo
        title={`${post.title} | Briljans`}
        description={post.description}
        path={`/blogg/${post.slug}`}
        image={`/images/blogg/${post.slug}.png`}
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <Link to="/blogg" className="blog-back"><ArrowLeft size={15} /> Alla artiklar</Link>
      <div className="blog-card-meta">
        <span>{fmtDate(post.date)}</span>
        <span className="blog-card-reading"><Clock size={13} /> {post.readingMinutes} min läsning</span>
      </div>
      <h1>{post.title}</h1>
      <article className="blog-body" dangerouslySetInnerHTML={{ __html: post.html }} />
      <div className="blog-cta">
        <h2>Nyfiken på vad din hemsida skulle kosta?</h2>
        <p>Testa vår priskalkylator eller be om en gratis prototyp — du betalar först när du är nöjd.</p>
        <div className="blog-cta-actions">
          <Link to="/priskalkylator" className="btn-primary">Räkna ut ditt pris</Link>
          <a href="/#contact" className="btn-secondary">Få en gratis prototyp</a>
        </div>
      </div>
    </div>
  );
}
